import { createSlice } from "@reduxjs/toolkit";
import {
  getPredictionsAsync,
  getPredictionByIdAsync,
  getNextPredictionsAsync,
  updatePredictionAsync,
} from "./actions";

const initialState = {
  isLoading: true,
  current: null,
  all: [],
  last: null,
  count: 0,
  counts: null,
};

export const predictionsSlice = createSlice({
  name: "predictions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPredictionsAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPredictionsAsync.fulfilled, (state, action) => {
        state.all = action.payload.predictions;
        state.last = action.payload.last;
        state.count = action.payload.totalPredictionsCount;
        if (action.payload.counts) {
          state.counts = action.payload.counts;
        }
        state.isLoading = false;
      })
      .addCase(getPredictionsAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getNextPredictionsAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getNextPredictionsAsync.fulfilled, (state, action) => {
        state.all = [...state.all, ...action.payload.predictions];
        state.last = action.payload.last;
        state.isLoading = false;
      })
      .addCase(getNextPredictionsAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getPredictionByIdAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPredictionByIdAsync.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isLoading = false;
      })
      .addCase(getPredictionByIdAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.current = null;
      })
      .addCase(updatePredictionAsync.fulfilled, (state, action) => {
        state.all = state.all.map((prediction) => {
          if (prediction.id === action.payload.id) {
            return { ...prediction, ...action.payload };
          } else {
            return prediction;
          }
        });
        state.isLoading = false;
      });
  },
});

export default predictionsSlice.reducer;
